import clienteAxios from "../config/axios";

export async function getAllTenants() {
    return clienteAxios.get('/tenant');
}

export async function getTenantByCodTenant(codTenant) {
    return clienteAxios.get(`/tenant/codTenant/${codTenant}`);
}

export async function addTenant(tenant) {
    return clienteAxios.post('/tenant', { tenant });
}

export async function updateTenant(tenant) {
    return clienteAxios.put('/tenant', { id: tenant._id, updates: tenant });
}

export async function deleteTenant(tenant) {
    return clienteAxios.delete('/tenant', { data: { id: tenant._id } });
}

export async function getTenantStats() {
    return clienteAxios.get('/tenant/stats');
}
